import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8b95a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "divider-title" }
const _hoisted_2 = { class: "divider-title" }
const _hoisted_3 = { class: "form-actions" }

import { SearchStation } from "@/types";
import { AppError } from "@/types/app.type";
import { ElForm, ElInput, ElMessage } from "element-plus";
import { reactive, ref, onMounted } from "vue";
import { getIssueType } from "@/service/issueType.service";
import { IssueType } from "@/types/issueMonitoring.type";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    values: null
  },
  emits: ["search"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "search", searh: SearchStation): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  values: SearchStation | undefined;
}

const { t } = useI18n();

// - refs
const form = ref<InstanceType<typeof ElForm> | null>(null);
const fieldQuery = ref<InstanceType<typeof ElInput> | null>(null);
const issueTypeList = ref<IssueType[]>([]);

// - properties


// - events


// - modelo formulario
const formModel = reactive<SearchStation>(
  props.values || {
    queryField: "ALL",
    query: "",
    group: "ALL",
    activeStatus: "ACTIVATED",
    issueStatus: "ALL",
    issueType: undefined,
    issueProcess: undefined,
  }
);

const process = [
  {
    label: t("statusIssue.UNREVIEWED"),
    value: "UNREVIEWED",
  },
  {
    label: t("statusIssue.IS-REVIEWED"),
    value: "IS-REVIEWED",
  },
  {
    label: t("statusIssue.DI-IN_PROGRESS"),
    value: "DI-IN_PROGRESS",
  },
  {
    label: t("statusIssue.DI-REVIEWED"),
    value: "DI-REVIEWED",
  },
  {
    label: t("statusIssue.EJ-OPEN"),
    value: "EJ-OPEN",
  },
  {
    label: t("statusIssue.EJ-CLOSE"),
    value: "EJ-CLOSE",
  },
  {
    label: t("statusIssue.EJ-OBSERVATION"),
    value: "EJ-OBSERVATION",
  },
];

// - validadores formulario
const rules = {};

// - methods
/**
 * method - onsubmit
 */
const onSubmit = async () => {
  if (!form.value) return;

  // - validate
  const valid = await form.value.validate();

  if (!valid) throw new Error(AppError.FORM_VALIDATION);

  // - emit search event
  emit("search", formModel);
};

const focus = () => {
  if (!fieldQuery.value) return;
  fieldQuery.value.focus();
};

onMounted(async () => {
  try {
    issueTypeList.value = await getIssueType();
  } catch (err) {
    ElMessage.error("Error al cargar las incidencias");
  }
});

expose({
  focus,
});

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElForm), {
    model: _unref(formModel),
    rules: rules,
    ref_key: "form",
    ref: form,
    "label-position": "top",
    class: "filter-form",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_divider, { "content-position": "left" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("btn.search")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_unref(ElInput), {
            modelValue: _unref(formModel).query,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).query) = $event)),
            placeholder: _ctx.$t('placeholder.search'),
            ref_key: "fieldQuery",
            ref: fieldQuery,
            clearable: "",
            class: "input-with-select"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(formModel).queryField,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).queryField) = $event)),
                style: {"width":"150px"},
                teleported: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "ALL",
                    label: _ctx.$t('enum.fields.ALL')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    value: "STATION_NAME",
                    label: _ctx.$t('enum.fields.STATION_NAME')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    value: "STATION_STATION",
                    label: _ctx.$t('enum.fields.STATION_STATION')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    value: "SAMPLINGPOINT_NAME",
                    label: _ctx.$t('enum.fields.SAMPLINGPOINT_NAME')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "group" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formModel).group,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).group) = $event)),
                    size: "default"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: "ALL" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.all")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "NO_OFFICE" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.field")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "OFFICE" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.office")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "activeStatus" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formModel).activeStatus,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).activeStatus) = $event)),
                    size: "default"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: "ALL" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.all")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "ACTIVATED" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.activated")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "DEACTIVATED" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.deactivated")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider, { "content-position": "left" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("label.issue")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "statusIssue" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formModel).issueStatus,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).issueStatus) = $event)),
                    size: "default"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: "ALL" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.all")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "ERROR" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("status.issue")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "OK" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("status.notissue")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 16
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "issueType" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(formModel).issueType,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formModel).issueType) = $event)),
                    "value-key": "id",
                    class: "w-full",
                    placeholder: _unref(t)('placeholder.selectIssueType'),
                    filterable: "",
                    clearable: "",
                    teleported: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issueTypeList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.name,
                          value: item.key
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 16
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "issueProcess" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(formModel).issueProcess,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formModel).issueProcess) = $event)),
                    "value-key": "id",
                    class: "w-full",
                    placeholder: _unref(t)('placeholder.selectStatus'),
                    filterable: "",
                    clearable: "",
                    teleported: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(process, (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "btn-search",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "mr-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_Search)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("placeholder.search")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "onSubmit"]))
}
}

})